import { defineComponent as _defineComponent } from 'vue'
import { getUserLocationCountryCode } from '@/helpers/geo-location-helper';
import { onMounted } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DachCampaign',
  setup(__props) {

onMounted(() => {
	let path = '/';
	const userCountry = getUserLocationCountryCode();

	switch (userCountry) {
		case 'AT':
			path = '/at/Film/man-with-no-past';
			break;
		case 'CH':
			path = '/ch/Film/man-with-no-past';
			break;
		case 'DE':
			path = '/de/Film/man-with-no-past';
			break;
	}

	window.location.href = path;
});

return { __sfc: true, }
}

})